<nz-row style="padding: 5px 5px 10px 5px;">
  <nz-col [nzSpan]="24" [ngClass]="isConsolePage ? 'console' : 'standalone'">
    <nz-card nzBordered [nzTitle]="nzTitle" class="client-card shadow" [nzExtra]="nzExtra">

      <ng-template #nzTitle>
        <div style="display: flex; align-items: center;">
          <nz-avatar nzIcon="apartment" style="margin-right:10px" [nzSrc]="getIcon(clientData)"></nz-avatar>
          <h1 class="heading-text"> <strong>{{clientData?.name}}</strong></h1>
        </div>
      </ng-template>
      <ng-template #nzExtra>

        <button nz-button nzType="default" (click)="openWebsite(clientData.website)">
          <span nz-icon nzType="global"></span> Website
        </button>

        <button nz-button nzType="default" style="margin-left:10px;float:inline-end" (click)="editClient(clientData)">
          <nz-icon nzType="edit" nzTheme="fill" />
        </button>
        <button
          nz-button
          nzDanger
          style="margin-left:10px;float:inline-end"
          [nz-popconfirm]="deleteClientPopconfirm"
          [nzPopconfirmTitle]="''"
          [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
          nzPopconfirmPlacement="bottom"
          (nzOnConfirm)="deleteClient(clientData)"
        >
          <nz-icon nzType="delete" nzTheme="fill" />
        </button>
      </ng-template>

      <nz-descriptions nzBordered [nzColumn]="3">

        <ng-template #idTitle>
          <h4 style="width:100px"><i nz-icon nzType="idcard"></i> Client ID</h4>
        </ng-template>
        <nz-descriptions-item [nzTitle]="idTitle">
          <nz-tag> {{ formatIdToFourDigits(clientData?.id , 'CL') }} </nz-tag>
        </nz-descriptions-item>

        <ng-template #pocNameTitle>
          <h4 style="width:120px"><nz-icon nzType="user-switch" nzTheme="outline" /> POCs</h4>
        </ng-template>
        <nz-descriptions-item [nzTitle]="pocNameTitle" [nzSpan]="2">

          <ng-container *ngIf="clientData?.poc_details?.length > 0; else noPOCFound">
            <nz-tag nzColor="success">
              <nz-icon nzType="user" />
              {{ getPrimaryPoc(clientData) }}
            </nz-tag>
          </ng-container>

          <ng-template #noPOCFound>
            No POC added yet.
          </ng-template>

          <button *ngIf="clientData?.poc_details" nz-button nzType="default" nzSize="small" (click)="showPOCModal()"
            nz-tooltip [nzTooltipTitle]="'View All POCs details'" nzTooltipPlacement="top">
            <nz-icon nzType="eye" nzTheme="outline" />
            <span *ngIf="clientData.poc_details.length > 1">+{{ clientData.poc_details.length - 1 }}</span>
          </button>

          <button nz-button nzType="default" nzSize="small" style="margin-left: 8px;" nz-tooltip
            [nzTooltipTitle]="'Add a New POC'" (click)="openAddPoc()" nzTooltipPlacement="top">
            <nz-icon nzType="plus" nzTheme="outline" />
          </button>

        </nz-descriptions-item>



        <ng-template #joiningDateTitle>
          <h4 style="width:120px"><i nz-icon nzType="calendar"></i> Onboarding Date</h4>
        </ng-template>
        <nz-descriptions-item [nzTitle]="joiningDateTitle">
        {{ clientData?.onboarding_date | date: 'dd MMM yyyy' }}
        </nz-descriptions-item>


        <ng-template #clientPhoneTitle>
          <h4 style="width:120px"><i nz-icon nzType="phone"></i> Client Phone</h4>
        </ng-template>
        <nz-descriptions-item [nzTitle]="clientPhoneTitle">
        {{clientData?.country_code_details?.code}}  {{ clientData?.phone }}
        </nz-descriptions-item>




        <ng-template #linkedinTitle>
          <h4><i nz-icon nzType="linkedin" style="color: grey !important;"></i> Client LinkedIn</h4>
        </ng-template>
        <nz-descriptions-item [nzTitle]="linkedinTitle">
          <a [href]="clientData?.linkedin" target="_blank"><nz-icon   nzType="linkedin" nzTheme="fill"
              style="font-size: 25px;" /></a>

        </nz-descriptions-item>


        <ng-template #salespersonTitle>
          <h4> <i nz-icon nzType="user"></i> Salesperson</h4>
        </ng-template>
        <nz-descriptions-item [nzTitle]="salespersonTitle">

          <nz-avatar nzSize="small" *ngIf="clientData?.salesperson_name"
            [nzText]="clientData?.salesperson_name[0].toUpperCase()" nz-tooltip
            [nzTooltipTitle]="titleTemplate" nzTooltipPlacement="top"
            [nzSrc]="getBase64Image(clientData?.salesperson_image)"></nz-avatar>
          {{ clientData?.salesperson_name ? clientData?.salesperson_name : ' &nbsp;-' }}

          <ng-template #titleTemplate let-thing>
            <ul style="padding: 10px 20px;margin:0px;font-size: 11px;">
              <li *ngIf="clientData?.salesperson_name">{{clientData?.salesperson_name}}</li>
              <li *ngIf="clientData?.salesperson_email">{{clientData?.salesperson_email}}</li>
              <li *ngIf="clientData?.salesperson_phone.phone_number != null">
                {{clientData?.salesperson_phone?.country_code}}
                {{clientData?.salesperson_phone?.phone_number}}

              </li>
            </ul>
         </ng-template>
        </nz-descriptions-item>




        <ng-template #addressTitle>
          <h4> <i nz-icon nzType="environment"></i> Address</h4>
        </ng-template>

        <nz-descriptions-item [nzTitle]="addressTitle">


          <div style="display: flex; ">


            <ng-container *ngIf="clientData?.address?.length > 0; else noAddressFound">


              {{ formattedAddress }}


            </ng-container>

            <ng-template #noAddressFound>
              No address added yet.
            </ng-template>



            <div style="display: flex;">
              <button *ngIf="clientData?.address && clientData?.address.length > 0" nz-button nzType="default"
                nzSize="small" (click)="showModal()" style="margin-left: 8px;" nz-tooltip
                [nzTooltipTitle]="'View All addresses'" nzTooltipPlacement="top">
                <nz-icon nzType="eye" nzTheme="outline" />
                <span *ngIf="clientData.address.length > 1">+{{ clientData.address.length - 1 }}</span>
              </button>

              <button nz-button nzType="default" nzSize="small" style="margin-left: 8px;" nz-tooltip
                [nzTooltipTitle]="'Add a new address'" (click)="openAddAddress()" nzTooltipPlacement="top">
                <nz-icon nzType="plus" nzTheme="outline" />
              </button>
            </div>


          </div>



        </nz-descriptions-item>

      </nz-descriptions>
    </nz-card>
  </nz-col>
</nz-row>



<nz-row style="padding: 5px 5px 10px 5px;">
  <nz-col [nzSpan]="24" [ngClass]="isConsolePage ? 'console' : 'standalone'">
    <nz-tabset [nzSize]="'small'" (nzSelectedIndexChange)="onTabChange($event)" nzType="card"
      [(nzSelectedIndex)]="selectedTabIndex">
      <nz-tab [nzTitle]="nzTitleProjects">
        <ng-template #nzTitleProjects>
          <i nz-icon nzType="project"></i> Projects
        </ng-template>

        <nz-table #virtualTableP [nzBordered]="false" [nzVirtualItemSize]="40" [nzVirtualForTrackBy]="trackByIndex"
          [nzFrontPagination]="false" [nzShowPagination]="false" [nzScroll]="{ x: '1000px', y: '200px' }"
          [nzSize]="'small'" [nzData]="listOfProject">
          <thead>
            <tr>
              <th nzWidth="10%">ID</th>
              <th nzWidth="20%">Project Name</th>
              <th nzWidth="25%">Progress</th>
              <th nzWidth="10%">Status</th>
              <th nzWidth="20%">Due Date</th>
              <th nzWidth="20%">CSM</th>
            </tr>
          </thead>
          <tbody>
            <ng-template nz-virtual-scroll let-data let-index="index">
              <tr>
                <td> <nz-tag> {{ formatIdToFourDigits(data?.id , 'PR') }} </nz-tag></td>
                <td style="font-weight: bold;">
                  <a href="javascript:void(0)" (click)="goToProjectDetail(data,'project')">
                    {{ data.name }}</a>
                </td>
                <td><nz-progress [nzPercent]="data?.project_progress"></nz-progress></td>
                <td>{{ data?.status_name }}</td>
                <td>{{ data?.due_date | date:'yyyy-MM-dd' }}</td>
                <td>{{ data?.customer_success_manager_name }}</td>
              </tr>
            </ng-template>
          </tbody>
        </nz-table>
        <div class="pagination-load-more" *ngIf="loadingMore">
          <nz-spin nzSimple nzSize="small"></nz-spin>
          <span>Loading more…</span>
        </div>

      </nz-tab>

      <nz-tab [nzTitle]="nzTitleTasks">
        <ng-template #nzTitleTasks>
          <i nz-icon nzType="reconciliation"></i> Tasks
        </ng-template>

        <nz-table #virtualTableT [nzBordered]="false" [nzVirtualItemSize]="40" [nzVirtualForTrackBy]="trackByIndex"
          [nzFrontPagination]="false" [nzShowPagination]="false" [nzScroll]="{ x: '1000px', y: '200px' }"
          [nzSize]="'small'" [nzData]="listOfTasks">
          <thead>
            <tr>
              <th nzWidth="10%">ID</th>
              <th nzWidth="25%">Task</th>
              <th nzWidth="20%">Project</th>
              <th nzWidth="10%">Priority</th>
              <th nzWidth="15%">Due Date</th>
              <th nzWidth="15%">Status</th>
            </tr>
          </thead>
          <tbody>
            <ng-template nz-virtual-scroll let-task let-index="index">
              <tr>
                <td> <nz-tag> {{ formatIdToFourDigits(task?.id , 'TS') }} </nz-tag></td>
                <td style="font-weight: bold;"><a (click)="goToDetail(task,'task')">{{ task?.name }}</a></td>
                <td>{{ task?.project_name }}</td>
                <td>
                  <nz-tag [nzColor]="getPriorityColor(getTaskPriorityName(task.priority))">{{
                    getTaskPriorityName(task?.priority) }}</nz-tag>
                </td>
                <td>{{ task?.due_date | date:'yyyy-MM-dd' }}</td>
                <td>
                  <nz-tag [nzColor]="getStatusColor(task.task_status)">{{ task?.task_status_name }}</nz-tag>
                </td>
              </tr>
            </ng-template>
          </tbody>
        </nz-table>
        <div class="pagination-load-more" *ngIf="loadingMore">
          <nz-spin nzSimple nzSize="small"></nz-spin>
          <span>Loading more…</span>
        </div>


      </nz-tab>

      <nz-tab [nzTitle]="nzTitleEvents">
        <ng-template #nzTitleEvents>
          <i nz-icon nzType="calendar"></i> Events
        </ng-template>


        <nz-table [nzData]="recentEvents" [nzBordered]="true" [nzSize]="'small'" [nzShowPagination]="false">
        <thead>
            <tr>
                <th nzWidth="50%">Event</th>
                <th nzWidth="20%">Type</th>
                <th>Date</th>
                <th nzWidth="16%">Location</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let event of recentEvents">
                <td >
                    <strong><a href="/app/events/{{ event.id }}">
                        <img  nz-image [nzSrc]="'data:image/png;base64,' + event.photo"
                        [nzFallback]="defaultEventImage" class="event-image" style="width:70px; height:36px;margin-right:20px"
                        alt="">
                        {{event?.event_name.length >36 ? event?.event_name.slice(0, 36) + '...' : event?.event_name }}</a></strong>
                </td>
                <td>{{ event.event_type_name }}</td>
                <td>
                    <nz-tag [nzColor]="'processing'"  [nzBordered]="true"  *ngIf="event?.start_datetime"><nz-icon nzType="clock-circle" /> {{event?.start_datetime | date:'dd-MM-yyyy, HH:mm'}}</nz-tag>
                    <nz-tag [nzColor]="'warning'"  [nzBordered]="true" *ngIf="event?.end_datetime"> <nz-icon nzType="clock-circle" /> {{event?.end_datetime | date:'dd-MM-yyyy, HH:mm'}}</nz-tag></td>
                <td>{{ event.city_name }}, {{ event.country }}</td>
            </tr>
        </tbody>
    </nz-table>

      </nz-tab>
    </nz-tabset>
  </nz-col>
</nz-row>


<app-console-project-detail [isVisible]="showProjectDetail" [tabData]="selectData" [type]="selectedType"
  (openTaskDetailEventOnDetail)="goToTaskDetailModal($event)"
  (closeModal)="closeProjectDetail()"></app-console-project-detail>

<app-client-poc-detail [isVisible]="isVisiblePOC" [poc_details]="clientData?.poc_details" [showActions]="true"
  (closePoc)="closePOCModal($event)" (editPocEvent)="editPOC($event)"
  (pocDeletedEvent)="pocDeletedEvent($event)"></app-client-poc-detail>

<app-client-add-poc *ngIf="isVisibleAddPoc" [isVisible]="isVisibleAddPoc" [data]="editPocData" [clientID]="clientData?.id"
  (closeDrawer)="closeAddPocEvents($event)"
  [allPOCData]="clientData?.poc_details ? clientData?.poc_details : []"></app-client-add-poc>

<!--  (closeDrawerData)="closeAddPoc($event)"  -->

<app-client-add-address *ngIf="isVisibleAddAddress" [isVisible]="isVisibleAddAddress" [data]="addressData" [clientID]="clientData?.id"
  (closeDrawer)="closeAddAddressEvent($event)"></app-client-add-address>
<!--   (closeDrawerData)="closeAddAddress($event)" -->

<app-client-address-detail [isVisible]="isVisible" [data]="clientData?.address ? clientData?.address : []"
  (closeDrawer)="handleCancel($event)" (updateAddressEvent)="updateAddress($event)"></app-client-address-detail>

<app-loader *ngIf="loading"></app-loader>



<ng-template #deleteClientPopconfirm>
  <div class="custom-popconfirm-header">
    <span class="custom-popconfirm-title">Confirm Deletion</span>
  </div>
  <div class="custom-popconfirm-icon-area">
    <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
      <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
    </span>
  </div>
  <div class="custom-popconfirm-message description">
    Are you sure you want to delete this client?<br />
    <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
  </div>
</ng-template>
